export default __webpack_public_path__ + "static/media/cp_geo_cg.384e7dae.svg";